<template>
    <b-container fluid>
        <b-row>
            <b-col cols="12">
                <admin-page-header title="원청사 관리" description="Assessment 서비스를 이용하는 원청사 기업을 관리합니다."/>
            </b-col>
        </b-row>

        <b-row v-if="loading" class="admin-body-full-height">
            <b-col cols="12">
                <div class="d-flex align-items-center justify-content-center bgray-200 h-100">
                    <b-spinner class="align-middle mr-3"></b-spinner>
                    <h3 class="mb-0">Loading...</h3>
                </div>
            </b-col>
        </b-row>

        <b-row v-else class="assessment-panel mt-3">
            <b-col cols="12" class="h-md-100">
                <b-card no-body class="shadow-sm h-md-100 overflow-hidden" header-bg-variant="white">
                    <template #header>
                        <div class="d-flex align-items-center justify-content-between">
                            <h5 class="mb-0">원청사 리스트</h5>
                        </div>
                    </template>

                    <PageEmptyComponent v-if="loadError" compact :error="loadError" @retry="getClientsData"/>
                    <b-table
                        v-else
                        :items="clients"
                        :fields="client_record"
                        empty-html="<h6 class='mt-3 gray-400'>조회된 원청사가 없습니다.</h6>"
                        show-empty
                        sticky-header="100vh"
                        class="mb-0"
                        no-border-collapse
                        >
                        <template #cell(project_codes)="row">
                            <b-btn size="sm" variant="outline-secondary" @click="row.toggleDetails()">
                                {{ row.detailsShowing ? '닫기' : '확인하기' }}
                            </b-btn>
                        </template>

                        <template #row-details="row">
                            <div class="d-flex border rounded bg-white mb-3">
                                <div class="flex-grow-1 p-3">
                                    {{ row.item.project_codes ? row.item.project_codes : '연결된 프로젝트 없음' }}
                                </div>
                            </div>
                        </template>
                    </b-table>
                </b-card>
            </b-col>
        </b-row>
    </b-container>
</template>                          
 

<script>
import PageEmptyComponent from '@shared/components/admin/components/common/PageEmptyComponent.vue';
import { getErrorMessage } from '@core/utils/api/errorMessage';

export default {
    name: 'AdminClient',
    components: { PageEmptyComponent },
    data() {
        return {
            loading: false,
            loadError: '',
            clients: [],

            client_record: [
                {
                    key: 'index',
                    label: '번호',
                    sortable: true,
                    thClass: 'text-center mb-0',
                    tdClass: 'text-center'
                },
                {
                    key: 'company_id',
                    label: '기업 ID',
                    sortable: true,
                    thClass: 'mb-0'
                },
                {
                    key: 'company_name',
                    label: '기업명',
                    sortable: true,
                    thClass: 'mb-0'
                },
                {
                    key: 'company_code',
                    label: '사업자등록번호',
                    sortable: true,
                    thClass: 'mb-0'
                },
                {
                    key: 'project_codes',
                    label: '연결 프로젝트',
                    sortable: true,
                    thClass: 'mb-0'
                },
            ],
        }
    },
    async created () {
        await this.getClientsData()
    },
    methods: {
        async getClientsData() {
            this.loading = true;
            try {
                const response = await this.$axios.get('/company/clients');
                if (response.status === 200) {
                    this.clients = response.data;
                    this.loadError = '';
                }
            } catch (error) {
                console.error('Error searching users:', error);
                this.loadError = getErrorMessage(error, '원청사 목록을 불러오지 못했습니다.');
            } finally {
                this.loading = false;
            }
        }
    }
}
</script>

<style lang="scss">
</style>